<template>
  <!-- Persistent (`:timeout="-1"`) on purpose: a banner that disappears on its own would leave the
       user on a superseded release with no way back to the offer. Dismissing hides the bar but
       keeps the pending update — the router still swaps the release in on the next navigation. -->
  <v-snackbar
    v-model="visible"
    location="bottom"
    color="primary"
    :timeout="-1"
    :close-on-back="false"
    role="status"
  >
    {{ t("general.update.message") }}

    <template #actions>
      <v-btn variant="text" @click="applyUpdate">
        {{ t("general.update.action") }}
      </v-btn>
      <v-btn icon="mdi-close" variant="text" size="small" :aria-label="t('general.close')" @click="visible = false" />
    </template>
  </v-snackbar>
</template>

<script setup>
import { ref, watch } from "vue"
import { useI18n } from "vue-i18n"
import { applyUpdate, updateAvailable } from "@/services/versionCheck"

const { t } = useI18n()

const visible = ref(false)

// Mirrored into local state rather than bound to the flag directly, so closing the snackbar does
// not have to clear the pending-update flag the router guard depends on.
watch(updateAvailable, pending => {
  if (pending) visible.value = true
})
</script>
